import es from "./translations/es";
import pt from "./translations/pt";

export default {
  es,
  pt,
};
